export const BREAKPOINTS = {
    mobile: 0,
    tablet: 768,
    desktop: 1048,
  };
  